import { createTheme } from '@mui/material/styles';
import * as theme from '../theme';

const muiTheme = createTheme({
  palette: {
    primary: {
      main: theme.Colors.GoldDark, // Customize this
    },
    secondary: {
      main: theme.Colors.GrayDark,
    },
    tertiary: {
      main: theme.Colors.GrayMedium
    },
    off: {
      main: theme.Colors.GrayLight
    },
    on: {
      main: theme.Colors.Purple
    },
    background: {
      default: theme.Colors.White,
    },
    text: {
      primary: theme.Colors.GrayDark,
    },
  },
});

export default muiTheme;